import { render, staticRenderFns } from "./ReadTip.vue?vue&type=template&id=847ee1ca&scoped=true&"
import script from "./ReadTip.vue?vue&type=script&lang=js&"
export * from "./ReadTip.vue?vue&type=script&lang=js&"
import style0 from "./ReadTip.vue?vue&type=style&index=0&id=847ee1ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847ee1ca",
  null
  
)

export default component.exports